import * as t from './actionTypes';

const initialState = { isLoading: false, coupon: [] };

const couponReducer = (state = initialState, action) => {

  switch (action.type) {
    case t.SET_BUSY:
      return Object.assign({}, state, { isLoading: true });

    case t.UNSET_BUSY:
      return Object.assign({}, state, { isLoading: false });

    case t.COUPON_LOAD_SUCCESS:
      let { coupon } = action;
      let value = coupon;
      if (coupon) {
        if (!Array.isArray(coupon)) {
          value = Object.keys(coupon).map(id => ({
            ...coupon[id],
            id,
          }));
        }
        return ({
          ...state,
          coupon: value,
        })
      }
      else {
        return state;
      }

    default:
      return state;
  }
};

export default couponReducer;
